<template>
    <div class="component-upload-image">
      <el-upload
        action=""
        :http-request="uploadFile"
        list-type="picture-card"
        :before-upload="handleBeforeUpload"
        :limit="limit"
        :on-exceed="handleExceed"
        name="file"
        :on-remove="handleRemove"
        :accept="acceptString"
        :show-file-list="true"
        :headers="headers"
        v-model:file-list="fileList"
        :on-preview="handlePictureCardPreview"
        :class="{hide: this.fileList.length >= this.limit}"
      >
        <i class="el-icon-plus"></i>

      </el-upload>
      <!-- 自定义上传提示 -->
      <span class="el-upload__tip" slot="tip" v-if="showCustomTip">
          {{ customTip }}
      </span>
      <!-- 上传提示 -->
      <span class="el-upload__tip" slot="tip" v-if="showTip">
        
        <template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>，
        <template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
        
      </span>
      
   
      <el-dialog
        :visible.sync="dialogVisible"
        title="预览"
        width="800"
        append-to-body
      >
        <img
          :src="dialogImageUrl"
          style="display: block; height: 600px;; margin: 0 auto"
        />
      </el-dialog>
    </div>
  </template>
   
  <script>
//   import authToken from "../../util/auth";
  import {mapGetters} from "vuex";
//   import request from '@/plugins/axios'
  import {BASEURL} from "@/config/index"
import { uploadPic } from "@/api/file"

  export default {
    name:'imageUpload',
    props: {
      value: [String, Object, Array],
      // 图片数量限制
      limit: {
        type: Number,
        default: 1,
      },
      // 大小限制(MB)
      fileSize: {
        type: Number,
        default: 5,
      },
      // 文件类型, 例如['png', 'jpg', 'jpeg']
      fileType: {
        type: Array,
        default: () => ["png", "jpg", "jpeg"],
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: true
      },
      // 是否显示自定义提示
      isShowCustomTip: {
        type: Boolean,
        default: false
      },
        customTip: {
            type: String,
            default: ''
      }

    },
    data() {
      return {
        dialogImageUrl: "",
        dialogVisible: false,
        acceptString:'.png,.jpeg,.jpg',
        hideUpload: false,
        uploadImgUrl: "", // 上传的图片服务器地址
        headers: {
          Authorization: this.token,
        },
        fileList: []
      };
    },
    watch: {
      value: {
        handler(val) {
          if (val) {
            // 首先将值转为数组
            const list = Array.isArray(val) ? val : this.value.split(',');
            // 然后将数组转为对象数组
            this.fileList = list.map(item => {
              if (typeof item === "string") {
                item = { name: item, url: item };
              }
              return item;
            });
          } else {
            this.fileList = [];
            return [];
          }
        },
        deep: true,
        immediate: true
      }
    },
    computed: {
        ...mapGetters(["token"]),
          // 是否显示提示
      
      showTip() {
        return this.isShowTip && (this.fileType || this.fileSize);
      },
      showCustomTip() {
        return this.isShowCustomTip ;
      },
   
    },
    created() {
          // this.uploadImgUrl = BASEURL+'/file/uploadPic'
        console.log(this.fileType);
        let acceptFileList = this.fileType
        let acceptList = []
        acceptFileList.forEach((ele) => {
          // console.log(ele);
            ele = '.' + ele;
            acceptList.push(ele)

        })
        this.acceptString = acceptList.join(',')
    },
    methods: {
        async uploadFile(params) {
          
          const file = params.file;
          // 使用FormData传参数和文件
          var form = new FormData();
          // 文件
          form.append("file", file);
          form.append("isFace", false);
          // 调用封装好的上传方法，传给后台FormData
          let { status, data, message } = await uploadPic(form)
          if (status) {
            console.log(data);
            this.$message.success(message);

             this.fileList.push({ id:data.id,name: file.name, url: data.savepath });
             this.$emit("fileList", this.fileList)
              // this.$emit("input", this.listToString(this.fileList));
            this.loading.close();
            
            } else {
              this.$message.error(message);
              this.loading.close();

          }
          
      },
      // 删除图片
      handleRemove(file, fileList) {
        const findex = this.fileList.map(f => f.name).indexOf(file.name);
        if(findex > -1) {
          this.fileList.splice(findex, 1);
          this.$emit("fileList", this.fileList)
          // this.$emit("input", this.listToString(this.fileList));
        }
      },
      // 上传成功回调
      handleUploadSuccess(res) {
        console.log(res);
        // if (res.status) {
        //   this.fileList.push({ name: res.data, url: BASEURL + res.data });
        //   this.$emit("input", this.listToString(this.fileList));
        //   this.loading.close();
        // } else {
        //   this.$message.error(res.message);
        //   this.loading.close();
        // }
      },
      // 上传前loading加载
      handleBeforeUpload(file) {
        let isImg = false;
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some((type) => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }
   
        if (!isImg) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
          );
          return false;
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$message.error(`上传图片大小不能超过 ${this.fileSize} MB!`);
            return false;
          }
        }
        this.loading = this.$loading({
          lock: true,
          text: "上传中",
          background: "rgba(0, 0, 0, 0.7)",
        });
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
      },
      // 上传失败
      // handleUploadError(res) {
      //   this.$message({
      //     type: "error",
      //     message: "上传失败",
      //   });
      //   this.loading.close();
      // },
      // 预览
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      // 对象转成指定字符串分隔
      // listToString(list, separator) {
      //   let strs = "";
      //   separator = separator || ",";
      //   for (let i in list) {
      //     strs += list[i].url + separator;
      //   }
      //   return strs != '' ? strs.substr(0, strs.length - 1) : '';
      // }
    }
  };
  </script>
  <style scoped lang="scss">
  // .el-upload--picture-card 控制加号部分
  ::v-deep.hide .el-upload--picture-card {
    display: none;
  }
  // 去掉动画效果
  ::v-deep .el-list-enter-active,
  ::v-deep .el-list-leave-active {
    transition: all 0s;
  }
   
  ::v-deep .el-list-enter, .el-list-leave-active {
    opacity: 0;
    transform: translateY(0);
  }
  >>>.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  >>>.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  </style>